import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AppConfigService } from '../../app-config.service';

@Injectable({ providedIn: 'root' })
export class AccessEditingSalesOrdersGuard {
  private readonly configService = inject(AppConfigService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const config = this.configService.config;
    if (config?.userCanAccessOrders) {
      return true;
    } else {
      const accountGroupId = route.paramMap.get('businessId');
      const orderId = route.paramMap.get('orderId');
      return this.router.createUrlTree(['order-management', accountGroupId, 'sales-order', orderId]);
    }
  }
}
